<template>
    <footer class="footer">
        <div class="footer__container -wrap">
            <Logo class="footer__logo" type="footer-logo"/>
        </div>
        <div class="footer__container -wrap">
            <ul class="footer__list">
                <li class="footer__line -title" v-html="$t('Footer.eduhouse')"></li>
                <li class="footer__line -address" v-html="addressLine"></li>
                <li class="footer__line " v-html="$t('Footer.row1_label')"></li>
                <img src="@/assets/images/ISO27001-ISO27701-certificate-logo.png" class="footer__iso-certificate-logo" :alt="$t('Footer.iso_certificate_alt')"/>
            </ul>

            <ul class="footer__list --support">
                <li class="footer__line -title" v-html="$t('Footer.customer_support')"></li>
                <li class="footer__line -open-hours" v-html="$t('Footer.open_hours')"></li>
                <FooterHubspotChat />
                <FooterLink :url="$t('Footer.contact_us_url')" :label="$t('Footer.contact_us')" icon="contact" />
                <FooterLink :url="$t('Footer.email')" :label="$t('Footer.email')" icon="email" />
                <FooterLink :url="$t('Footer.phone_number')" :label="$t('Footer.phone_number')" icon="phone" />
                <FooterLink :url="$t('Footer.faq_url')" :label="$t('Footer.faq')" icon="faq" />
            </ul>

            <ul class="footer__list -privacy">
                <li class="footer__line -title" v-html="$t('Footer.privacy_and_terms')"></li>
                <FooterLink :url="$t('Footer.row3_url')" :label="$t('Footer.row3_label')" />
                <FooterLink :url="$t('Footer.row4_url')" :label="$t('Footer.row4_label')" />
                <li class="footer__line">
                    <router-link :to="{ name: 'accessibility-form' }">{{ $t('Footer.accessibilityStatement_label') }}</router-link>
                </li>
                <a class="footer__consent-button" href="javascript: Cookiebot.show()" v-html="$t('Footer.cookies')"></a>
            </ul>
            <ul class="footer__list">
                <FooterSocials class="footer__socials" />
                <FooterLink :url="'https://' + $t('StoreMenu.home')" :label="$t('StoreMenu.home')" class="footer__homepage" />
                <FooterSubscribe v-if="showFooterSubscribe && !isTabletAndMobileView" />
            </ul>
        </div>
        <FooterSubscribe v-if="showFooterSubscribe && isTabletAndMobileView" class="footer__subscribe"/>
    </footer>
</template>

<script>
    import FooterLink from 'components/layout/footer/footer-link'
    import FooterSubscribe from 'components/layout/footer/footer-subscribe'
    import FooterSocials from 'components/layout/footer/footer-socials'
    import FooterHubspotChat from 'components/layout/footer/footer-hubspot-chat'
    import Logo from 'components/layout/Logo'
    import { mapGetters } from 'vuex'
    import SelectLanguage from 'components/layout/SelectLanguage'

    export default {
        name: 'footer-eduhouse',
        components: {
            Logo,
            FooterSocials,
            FooterSubscribe,
            FooterLink,
            FooterHubspotChat,
            SelectLanguage
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                showFooterSubscribe: 'User/getShowFooterSubscribe'
            }),
            addressLine () {
                return this.$t('Footer.address_line_1') + ', ' + this.$t('Footer.address_line_2')
            },
            isTabletAndMobileView () {
                return this.$mq.includes('mobile_sm') || this.$mq.includes('mobile_md') || this.$mq.includes('desktop_l') || this.$mq.includes('desktop_xl')
            }
        }
    }
</script>

<style lang="scss" scoped>
    @include footer;
</style>
